/**
 * wstch-blog-toc.js
 * Auto-generates a table of contents from article h2/h3 headings.
 * Scroll-spy highlights the current section.
 */
(function () {
  var container = document.getElementById('wstch-article-body');
  var tocList = document.getElementById('wstch-toc-list');
  if (!container || !tocList) return;

  var headings = container.querySelectorAll('h2, h3');
  if (headings.length < 2) {
    var tocBlock = document.getElementById('wstch-toc');
    if (tocBlock) tocBlock.style.display = 'none';
    return;
  }

  // Build TOC
  var fragment = document.createDocumentFragment();
  headings.forEach(function (h, i) {
    var id = 'wstch-s-' + i;
    h.id = id;

    var li = document.createElement('li');
    li.className = 'wstch-toc__item' + (h.tagName === 'H3' ? ' wstch-toc__item--sub' : '');

    var a = document.createElement('a');
    a.href = '#' + id;
    a.textContent = h.textContent;
    a.className = 'wstch-toc__link';
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById(id);
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: top, behavior: 'smooth' });
      history.replaceState(null, '', '#' + id);
    });

    li.appendChild(a);
    fragment.appendChild(li);
  });
  tocList.appendChild(fragment);

  // Scroll spy
  var links = tocList.querySelectorAll('.wstch-toc__link');
  var ids = [];
  links.forEach(function (l) { ids.push(l.getAttribute('href').slice(1)); });

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var scrollY = window.pageYOffset + 120;
      var current = '';
      for (var i = 0; i < ids.length; i++) {
        var el = document.getElementById(ids[i]);
        if (el && el.offsetTop <= scrollY) current = ids[i];
      }
      links.forEach(function (l) {
        l.classList.toggle('is-active', l.getAttribute('href') === '#' + current);
      });
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Mobile toggle
  var toggle = document.getElementById('wstch-toc-toggle');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var list = document.getElementById('wstch-toc-list');
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !expanded);
      list.style.display = expanded ? 'none' : 'block';
    });
  }
})();
